import React, { useState, useEffect } from "react";

export default function PushNotificationsCard() {
  const [status, setStatus] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarStatus();
  }, []);

  const carregarStatus = async () => {
    try {
      const res = await fetch("/api/push/status");
      const data = await res.json();
      if (data.success) {
        setStatus(data.permission);
        setSubscriptions(data.subscriptions || []);
      }
    } catch (e) {
      console.error("Erro ao carregar status push:", e);
    }
  };

  const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };

  const handleAtivar = async () => {
    try {
      setCarregando(true);
      if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        window.alert("Seu navegador não suporta notificações push.");
        return;
      }

      const permission = await Notification.requestPermission();
      setStatus(permission);

      if (permission !== "granted") {
        window.alert("Permissão de notificações negada.");
        return;
      }

      const reg = await navigator.serviceWorker.ready;
      const keyRes = await fetch("/api/push/vapid-public-key");
      const keyData = await keyRes.json();

      if (!keyData.success || !keyData.publicKey) {
        window.alert("Chave VAPID não configurada.");
        return;
      }

      const convertedVapidKey = urlBase64ToUint8Array(keyData.publicKey);
      let sub = await reg.pushManager.getSubscription();
      
      if (!sub) {
        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: convertedVapidKey,
        });
      }

      const deviceLabel = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? "Celular / Tablet"
        : "Computador / Desktop";

      const saveRes = await fetch("/api/push/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subscription: sub, deviceLabel }),
      });

      const saveData = await saveRes.json();
      if (saveData.success) {
        window.alert("Dispositivo ativado com sucesso!");
        carregarStatus();
      } else {
        window.alert("Erro ao salvar inscrição: " + (saveData.error || "Desconhecido"));
      }
    } catch (e) {
      console.error("Erro ao ativar:", e);
      window.alert("Erro ao ativar notificações: " + e.message);
    } finally {
      setCarregando(false);
    }
  };

  const handleEnviarTeste = async () => {
    try {
      const res = await fetch("/api/push/test", { method: "POST" });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) {
        window.alert(data.message || "Teste enviado com sucesso!");
      } else {
        window.alert("Erro no servidor: " + (data.error || res.statusText));
      }
    } catch (e) {
      window.alert("Erro de conexão ao enviar teste: " + e.message);
    }
  };

  const handleExcluir = async (id) => {
    if (!window.confirm("Deseja realmente remover este dispositivo?")) return;
    try {
      const res = await fetch(`/api/push/subscriptions/${id}`, { method: "DELETE" });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) {
        window.alert("Dispositivo removido com sucesso!");
        carregarStatus();
      } else {
        window.alert("Erro ao remover: " + (data.error || "Desconhecido"));
      }
    } catch (e) {
      window.alert("Erro de conexão ao excluir.");
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-800">Notificações no celular</h3>
        <p className="text-sm text-gray-500">Receba alertas do FINANCY Limpa Nome diretamente neste dispositivo.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
          <span className="text-xs text-gray-400 block uppercase font-medium">Suporte</span>
          <span className="text-sm font-semibold text-gray-700">
            {"serviceWorker" in navigator && "PushManager" in window ? "Disponível" : "Indisponível"}
          </span>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
          <span className="text-xs text-gray-400 block uppercase font-medium">Permissão</span>
          <span className="text-sm font-semibold text-gray-700">{status || "Desconhecida"}</span>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
          <span className="text-xs text-gray-400 block uppercase font-medium">Dispositivos Ativos</span>
          <span className="text-sm font-semibold text-gray-700">{subscriptions.length}</span>
        </div>
      </div>

      <div className="flex flex-wrap gap-3 mb-6">
        <button
          onClick={handleAtivar}
          disabled={carregando}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition disabled:opacity-50"
        >
          {carregando ? "Processando..." : "Ativar neste dispositivo"}
        </button>
        <button
          onClick={handleEnviarTeste}
          className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition"
        >
          Enviar teste
        </button>
      </div>

      <div>
        <h4 className="text-sm font-semibold text-gray-700 mb-3">Dispositivos Vinculados</h4>
        {subscriptions.length === 0 ? (
          <p className="text-xs text-gray-400">Nenhum dispositivo cadastrado ainda.</p>
        ) : (
          <div className="space-y-2">
            {subscriptions.map((sub) => (
              <div key={sub.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-100">
                <div>
                  <p className="text-sm font-medium text-gray-800">{sub.device_label || "Dispositivo Web"}</p>
                  <p className="text-xs text-gray-400">ID: {sub.id} | Cadastrado em: {new Date(sub.created_at).toLocaleDateString("pt-BR")}</p>
                </div>
                <button
                  onClick={() => handleExcluir(sub.id)}
                  className="text-xs bg-red-50 hover:bg-red-100 text-red-600 border border-red-200 px-3 py-1.5 rounded-md font-medium transition"
                >
                  Excluir
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
